export default __webpack_public_path__ + "static/media/products.d41db0f7.csv";